export default __webpack_public_path__ + "static/media/carouselEight.f3a765be.png";